/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Cta_TitleInputs */

const en_svc_integration_cta_title = /** @type {(inputs: Svc_Integration_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring the systems, and the step between them.`)
};

const lv_svc_integration_cta_title = /** @type {(inputs: Svc_Integration_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet sistēmas un soli, kas ir starp tām.`)
};

/**
* | output |
* | --- |
* | "Bring the systems, and the step between them." |
*
* @param {Svc_Integration_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_cta_title = /** @type {((inputs?: Svc_Integration_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_cta_title(inputs)
	return en_svc_integration_cta_title(inputs)
});